import { PaginacionProps } from "../global/PaginacionInterface";
import { ExpedienteProps, defaultExpediente } from "../recepcion/ExpedienteInterface";

export const defaultBuscarLibroSentenciaInterlocutoriaResponse: BuscarLibroSentenciaInterlocutoriaResponse = { currentPageIndex: 0, pageCount: 0, recordCount: 0, records: [], };

export const defaultBuscarLibroSentenciaInterlocutoria: BuscarLibroSentenciaInterlocutoria = { idAutoridad: 0, numeroReferencia: '', idTipoConsecutivo: 0 };

export const defaultLibroSentenciaInterlocutoria: LibroSentenciaInterlocutoriaProps = { 
    idLibroSentenciaInterlocutoria: 0,
    idSentencia:                    0,
    numeroSentencia:                '',
    idExpediente:                   0,
    numeroExpediente:               '',
    sentidoSentencia:               '',
    prorroga:                       '',
    observaciones:                  '',
    documentoSentencia:             '',
    expediente:                     defaultExpediente,
};


export interface LibroSentenciaInterlocutoriaProps {
    idLibroSentenciaInterlocutoria: number;
    idSentencia:                    number;
    numeroSentencia:                string;
    idExpediente:                   number;
    numeroExpediente:               string;
    sentidoSentencia:               string;
    prorroga:                       string;
    observaciones:                  string;
    documentoSentencia:             string;
    fechaCitacionSentencia?:        Date;
    fechaSentencia?:                Date;
    fechaProrroga?:                 Date;
    expediente:                     ExpedienteProps;
}

export interface BuscarLibroSentenciaInterlocutoria {
    idAutoridad:        number;
    numeroReferencia:   string;
    idTipoConsecutivo?: number;
}

export interface BuscarLibroSentenciaInterlocutoriaParams extends PaginacionProps, BuscarLibroSentenciaInterlocutoria { }

export interface BuscarLibroSentenciaInterlocutoriaResponse {
    currentPageIndex:   number;
    pageCount:          number;
    recordCount:        number;
    records:            LibroSentenciaInterlocutoriaProps[];
}

export interface GuardarObservaciones {
    id:             number;
    observaciones:  string;
}

export interface DescargarInformacionParams { 
    idAutoridad:        number;
    numeroReferencia:   string;
    idTipoConsecutivo?: number;
}